const PAYMENT_SERVER_URL =  'http://localhost:4000/payment';

export default PAYMENT_SERVER_URL;